import { CurrentUser, GetUserData } from "common/service/CommonService";
import { APIClient } from "../../../api/api_helper";
import { AUDIT_API } from "../../../api/url_helper";
import { AuditPayload } from "../helper/audit.types";

const api = new APIClient();

export const auditApiService = {
  getModuleDropdownData: () => {
    return api.create(AUDIT_API.AUDIT_API + "ModuleDropdown", {});
  },

  getAuditSelectAllData: (data: AuditPayload) => {
    const user = GetUserData() as CurrentUser;
    const payload = {
      fromdate: null,
      todate: null,
      modulename: null,
      operationtype: null,
      recordid: null,
      recordids: null,
      createdby: null,
      refid: null,
      studyid: null,
      searchtext: null,
      generatedby: user.userid,
      recordname: null,
      logbookname: null,
      entryname: null,
      detailEntryName: null,
      useractivity: null,
      companyname: 'adrta technologies private limited',
      companylogo: null,
      companytagline:'Information Technology & Services',
      timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
      ...data,
    };
    return api.create(AUDIT_API.AUDIT_API + "SelectAll", payload, { responseType: 'blob' });
  },

  getRecordDropdownData: (payload: any) => {
    return api.create(AUDIT_API.AUDIT_API + "RecordDropdown", payload);
  },

  getChildModuleDropdownData: (payload: any) => {
    return api.create(AUDIT_API.AUDIT_API + "ChildModuleDropdown", payload);
  },

  getLoginSelectAllData: (payload?: any) => {
    const payload_data = {
      currentpage: payload?.currentpage ?? 1,
      pagesize: payload?.pagesize ?? 10,
      ispagination: payload?.ispagination ?? false,
      fromdate: payload?.fromdate ?? null,
      todate: payload?.todate ?? null,
      useractivity: payload?.useractivity ?? null,
    };
    return api.create(AUDIT_API.AUDIT_API + "Login/SelectAll", payload_data);
  },
};
